import { decodeBase64Url } from './encode-base64';
import { CheckoutDataDecodeError, EmptyCheckoutDataError, LowercaseCheckoutDataError, StatusDataDecodeError, toError } from './errors';
export function decodeCheckoutData(encoded) {
  if (!encoded) {
    throw new EmptyCheckoutDataError();
  }
  try {
    return decodeBase64Url(encoded);
  } catch (err) {
    // btoa('{"') produces 'eyI=' meaning all our JSON encodings will start with "ey".
    //
    // Some crawlers tries to fetch lowercased URL leading to many decode failures. We throw special exception here
    // which we can ignore in reporting.
    if (encoded.startsWith('ey') && noUpperCase(encoded)) {
      throw new LowercaseCheckoutDataError(encoded);
    }
    throw new CheckoutDataDecodeError(toError(err).message);
  }
}
export function decodeStatusData(encoded) {
  try {
    return decodeBase64Url(encoded);
  } catch (err) {
    throw new StatusDataDecodeError(toError(err).message);
  }
}
const noUpperCase = str => !/[A-Z]/.test(str);
//# sourceMappingURL=decode-path-data.js.map